import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BulletLowerRomanIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletLowerRoman",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.11 4.29h.07c.28 0 .54-.1.75-.26.2-.2.33-.48.33-.79v-.1c0-.31-.12-.6-.33-.81a1.156 1.156 0 0 0-1.64 0c-.2.21-.33.49-.33.81v.09c0 .31.13.6.33.8.19.16.44.26.71.26h.12ZM7.22 6.1H9v7.41H7.22zM3.81 18.81c-.2.21-.33.49-.33.81v.02c0 .31.12.59.33.8.2.2.48.33.78.33h.06c.31 0 .58-.13.78-.33.23-.2.38-.49.4-.81 0-.33-.12-.61-.33-.82a1.185 1.185 0 0 0-1.7 0Zm-.07 3.77h1.78v7.41H3.74zm4.37-1.81c.32 0 .6-.12.81-.33.2-.2.33-.48.33-.78v-.03c0-.32-.12-.61-.33-.81s-.5-.33-.82-.33-.6.13-.82.33c-.2.21-.33.49-.33.81v.02c0 .31.12.59.33.8.2.2.47.33.78.33h.04Zm-.89 1.81H9v7.41H7.22zm20.38-4.04H13.1c-.5 0-.91.41-.91.91s.41.91.91.91h14.5c.5 0 .91-.41.91-.91s-.41-.91-.91-.91m-7.25 5.44H13.1c-.5 0-.91.41-.91.91s.41.91.91.91h7.25c.5 0 .91-.41.91-.91s-.41-.91-.91-.91M13.1 6.76h14.5c.5 0 .91-.41.91-.91s-.41-.91-.91-.91H13.1c-.5 0-.91.41-.91.91s.41.91.91.91m0 5.44h7.25c.5 0 .91-.41.91-.91s-.41-.91-.91-.91H13.1c-.5 0-.91.41-.91.91s.41.91.91.91"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.72 5.24c0-.68.56-1.24 1.25-1.24s1.24.56 1.24 1.24-.56 1.25-1.24 1.25-1.25-.57-1.25-1.25m.15 1.82h2.21v6.83H5.87zM4 18.98c0-.68.56-1.24 1.25-1.24s1.24.56 1.24 1.24-.56 1.25-1.24 1.25S4 19.66 4 18.98m.15 1.82h2.21v6.83H4.15zM7.43 18.98c0-.68.56-1.24 1.25-1.24s1.24.56 1.24 1.24-.56 1.25-1.24 1.25-1.25-.57-1.25-1.25m.16 1.82H9.8v6.83H7.59zM28.07 7.06H14.36a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.21 12.77h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M28.07 21.92H14.36a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.21 27.63h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};
BulletLowerRomanIcon.displayName = 'BulletLowerRomanIcon';